import { render } from "./fiveF_step_TwoView.vue?vue&type=template&id=33745e88&scoped=true"
import script from "./fiveF_step_TwoView.vue?vue&type=script&lang=js"
export * from "./fiveF_step_TwoView.vue?vue&type=script&lang=js"

import "./fiveF_step_TwoView.vue?vue&type=style&index=0&id=33745e88&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33745e88"]])

export default __exports__